import React, {useState, useEffect} from "react"
import {Div, Tag, Text, Input, Label, Switch, Textarea, Icon, Notification} from "atomize";
import styled, {createGlobalStyle} from "styled-components";
import ReactModal from 'react-modal';
import {ReactComponent as CloseIcon} from "../../../Assets/Icons/close.svg";
import { useScrollPosition } from './../../../utils/getScrollPosition';
import {apiGet} from "../../../Api";
import CoursePhases from "../../Paragraphs/CoursePhases";

const GlobalStyle = createGlobalStyle`
  .description p {
    padding: 1rem 0;
  }
  .ReactModal__Content--after-open {
      width: 800px;
      min-height: calc(100vh / 2);
      
      left: unset !important;
      right: unset !important;
      bottom: unset !important;
      border: none !important;
      
      padding: 2rem !important;
      
      @media (max-width: 880px) {
        width: unset;
        top: 20px !important;
        left: 20px !important;
        right: 20px !important;
        bottom: 20px !important;
        padding: 1rem !important;
      }
    }
    .ReactModal__Overlay.ReactModal__Overlay--after-open {
      z-index: 200;
    }
    .ReactModal__Overlay {
      background-color: #009bdf6b !important;
      display: flex;
      justify-content: center;
      opacity: 0;
      .ReactModal__Content {
        transform: scale(0);
        transition: transform 250ms ease-in-out;
      }
      transition: opacity 250ms ease-in-out;
    }
    
    .ReactModal__Overlay--after-open{
      .ReactModal__Content {
        transform: scale(1);
      }
        opacity: 1;
    }
    
    .ReactModal__Overlay--before-close{
      .ReactModal__Content {
        transform: scale(0);
      }
      opacity: 0;
    }
    
    // .ReactModal__Body--open {
    //    overflow: hidden;
    // }
    
    .activities {
      color: #4E5D78;	
      font-family: Inter;	
      font-size: 14px;	
      font-weight: 500;	
      line-height: 24px;
    }
`;

const CloseButton = styled.a`
  position: absolute;
  padding: 1rem;
  top: .5rem;
  right: .5rem;
`;

const Wrapper = styled.div`
 > div {
  margin-top: 1rem;
 }
`;

function getParent() {
  return document.querySelector('#root');
}

function PhaseModal(props) {
  const [coursePhases, setCoursePhases] = useState(null);

  useScrollPosition(({ prevPos, currPos }) => {
    if (props.open) {
      if ( Math.abs(prevPos.y - currPos.y) > 50 ) {
        props.close()
      }
    }
  }, [props.open]);

  useEffect(() => {
    ReactModal.setAppElement('#main');
    async function fetchData() {
      const result = await apiGet(`/node/page?filter[title]=activities&include=field_paragaphs&jsonapi_include=1`);
      const paragraphs = result.data.data[0].field_paragaphs;
      const coursePhases = paragraphs.filter( p => {
        return p.type === "paragraph--course_phases"
      })[0];
      setCoursePhases(coursePhases);
    }
    fetchData();
  }, []);


  return (
    <>
      <GlobalStyle/>
      <ReactModal
        isOpen={props.open}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => props.close()}
        parentSelector={getParent}
        closeTimeoutMS={250}
        data={{
          background: "green"
        }}
      >
        <CloseButton
          aria-label={'close'}
          tabIndex={0}
          onClick={() => props.close() }
        >
          <CloseIcon/>
        </CloseButton>
        <Wrapper>
          { coursePhases &&
          <CoursePhases
            id={coursePhases.id}
          />
          }
        </Wrapper>
      </ReactModal>
    </>
  )
}

export default PhaseModal
